import Flicking from '@egjs/react-flicking'
import { graphql, useStaticQuery } from 'gatsby'
import { decode } from 'html-entities'
import sortBy from 'lodash/sortBy'
import uniq from 'lodash/uniq'
import React, { useState } from 'react'
import { useDataLayer } from '../../hooks/useDataLayer'
import { useTranslations } from '../../hooks/useTranslations'

const M17JobsList = ({ heading, listType, anchorLinkId }) => {
  const dataLayer = useDataLayer()
  const translations = useTranslations()
  const [activeCity, setActiveCity] = useState(null)
  const data = useStaticQuery(graphql`
    {
      jobs: allJobsXml {
        nodes {
          name
          jobs: xmlChildren {
            children {
              name
              content
            }
          }
        }
      }
      apprenticeships: allApprenticeshipsXml(filter: { name: { eq: "jobs" } }) {
        nodes {
          name
          jobs: xmlChildren {
            children {
              name
              content
            }
          }
        }
      }
    }
  `)

  const nodes = data[listType || 'jobs'].nodes
  const jobNodes = nodes?.find(j => j.name === 'jobs').jobs
  const cities = uniq(
    sortBy(
      jobNodes
        .filter(
          job =>
            job.children.find(child => child.name === 'company')?.content ===
            'AS Aufz&#252;ge AG',
        )
        .map(job => job.children.find(child => child.name === 'city').content),
    ),
  )

  const jobs = jobNodes
    .map(job =>
      Object.values(job.children).reduce(
        (acc, cur) => ({ ...acc, [cur.name]: cur.content }),
        {},
      ),
    )
    .filter(job => job.company?.indexOf('AS Aufz&#252;ge AG') !== -1)

  return (
    <section className="my-10 overflow-hidden md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-g">
          <div className="col-1-type-g1">
            <h2 className="mb-5 u-h1">{heading}</h2>

            {/* <div className="flex items-center w-auto mb-12 space-x-8 overflow-x-auto"> */}
            <div className="mb-12">
              <Flicking autoInit align="prev">
                <button
                  type="button"
                  className={`mr-4 font-bold 5px] border-b-2 whitespace-nowrap ${
                    activeCity === null ? 'border-black' : 'border-transparent'
                  }`}
                  onClick={() => setActiveCity(null)}
                >
                  {translations.allLocations}
                </button>
                {cities.map(city => (
                  <button
                    key={city}
                    type="button"
                    className={`mx-4 font-bold text-[15px] border-b-2 whitespace-nowrap ${
                      activeCity === city
                        ? 'border-black'
                        : 'border-transparent'
                    }`}
                    onClick={() => setActiveCity(city)}
                  >
                    {decode(city)}
                  </button>
                ))}
              </Flicking>
            </div>

            <div>
              {jobs
                .filter(job => activeCity === null || job.city === activeCity)
                .map(job => (
                  <a
                    key={job.ID}
                    href={job.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-5 sm:px-7 md:px-8 lg:px-10 py-8 odd:bg-white rounded-[5px] group transition hover:bg-gray-2"
                    onClick={() =>
                      dataLayer.push({
                        event: 'userinteraction',
                        eventCategory: 'Offene Stellen',
                        eventAction: 'click',
                        eventLabel: decode(job.title),
                        event_location: null,
                      })
                    }
                  >
                    <div className="mb-1 u-p group-hover:text-red-as">
                      {decode(job.title)}
                    </div>
                    <div className="font-bold u-p-small">
                      {decode(job.city)}
                    </div>
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M17JobsList
